import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthorsUtils } from "../../utils";
import { AvisLoader } from "../shared/components";
import { AvisContext } from "../shared/context/AvisContext";
import { RightsHolder } from "./RightsHolder";

interface IRightsHolderHocProps {
  children: React.ReactNode;
}

export function RightsHolderHoc(props: Readonly<IRightsHolderHocProps>) {
  const { children } = props;
  const [isProfileSelected, setIsProfileSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const {
    ctxUser,
    ctxRightsHolder,
    ctxRightsHolders,
    shouldSelectRightsHolder,
    updateRightsHolder,
  } = useContext(AvisContext);
  const navigate = useNavigate();

  const hasPermission = useMemo(() => {
    return ctxUser?.isAuthor || ctxRightsHolders?.length === 0;
  }, [ctxRightsHolders, ctxUser]);

  useEffect(() => {
    if (ctxUser && !hasPermission) {
      setIsLoading(false);

      return;
    }

    setIsProfileSelected(
      !!ctxRightsHolder && AuthorsUtils.isValidRightHolder(ctxRightsHolder),
    );

    if (ctxRightsHolder) {
      AuthorsUtils.reloadCurrentUrlWithParams(ctxRightsHolder, navigate);
    } else if (!shouldSelectRightsHolder) {
      const preSelectedRightsHolder =
        AuthorsUtils.getRightsHolderFromUrl(ctxRightsHolders);

      updateRightsHolder(preSelectedRightsHolder ?? undefined);
    }

    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctxRightsHolder]);

  if (isLoading) return <AvisLoader />;

  if (!isProfileSelected) return <RightsHolder />;

  return children;
}
